/**
 * Monolith Host Interactive Plan Configurator & Live Node Ping Simulator
 */
export function initHostingShowcase() {
  const planTabs = document.querySelectorAll('.host-plan-tab');
  const priceDisplay = document.getElementById('hostPlanPrice');
  const planTitle = document.getElementById('hostPlanTitle');
  const planSub = document.getElementById('hostPlanSub');
  const featureList = document.getElementById('hostFeatureList');
  const planOrderBtn = document.getElementById('hostOrderBtn');

  // Plan Database matching monolith.host
  const plans = {
    vps: {
      title: 'KVM VPS — Plan I',
      sub: 'Dedicated KVM virtualization, high-frequency AMD Ryzen compute, full root access.',
      price: '$15',
      features: [
        '2 vCPU High-Frequency Cores',
        '4 GB DDR4/DDR5 RAM',
        '80 GB Enterprise NVMe SSD',
        'Unmetered 10 Gbps Bandwidth',
        'Enterprise Volumetric DDoS Shield',
        'Full Root Access & Custom ISOs',
        'Instant Automated Deployment (<60s)',
        'Global Datacenters (NY, LON, FRA)'
      ],
      link: 'https://monolith.host/cart?plan=vps-1'
    },
    game: {
      title: 'Game Server — Game Elite',
      sub: 'Ultra-low latency kernel tuned specifically for 128-slot FiveM & modded Minecraft.',
      price: '$50',
      features: [
        '8 vCPU AMD Ryzen 9 Cores',
        '16 GB High-Speed RAM',
        '200 GB Rapid NVMe Storage',
        'Up to 100+ Player Slots',
        'Application-Layer Game DDoS Filter',
        'One-Click TxAdmin & Resource Installer',
        '24/7 Priority Discord & Ticket Support',
        'Automated Daily Offsite Backups'
      ],
      link: 'https://monolith.host/cart?plan=game-elite'
    },
    dedicated: {
      title: 'Enterprise Dedicated — Dedicated III',
      sub: 'Maximum unshared bare-metal power with hardware RAID 10 & 25 Gbps uplink.',
      price: '$400',
      features: [
        'Dual Intel Xeon Gold Processors',
        '128 GB DDR4 ECC Registered RAM',
        '4x 2 TB NVMe SSD in Hardware RAID 10',
        '25 Gbps High-Throughput Uplink',
        'Enterprise SLA & DDoS Mitigation',
        'Dedicated IPMI / KVM Console Access',
        'Fully Managed OS & Migration Setup',
        '24/7 Dedicated Account Engineer'
      ],
      link: 'https://monolith.host/cart?plan=dedicated-3'
    }
  };

  if (planTabs.length > 0 && priceDisplay) {
    planTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        planTabs.forEach(t => t.classList.remove('is-selected'));
        tab.classList.add('is-selected');

        const key = tab.getAttribute('data-plan');
        const plan = plans[key] || plans.vps;

        priceDisplay.innerHTML = `${plan.price}<span>/month</span>`;
        if (planTitle) planTitle.textContent = plan.title;
        if (planSub) planSub.textContent = plan.sub;

        if (featureList) {
          featureList.innerHTML = plan.features.map(f => `
            <li class="host-feature-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg>
              <span>${f}</span>
            </li>
          `).join('');
        }

        if (planOrderBtn) {
          planOrderBtn.href = plan.link;
        }
      });
    });
  }

  // Live Datacenter Ping Simulator
  const pingNY = document.getElementById('pingNY');
  const pingLON = document.getElementById('pingLON');
  const pingFRA = document.getElementById('pingFRA');

  function simulatePingJitter() {
    if (pingNY) pingNY.textContent = `${(11 + Math.random() * 3).toFixed(1)} ms`;
    if (pingLON) pingLON.textContent = `${(23 + Math.random() * 4).toFixed(1)} ms`;
    if (pingFRA) pingFRA.textContent = `${(17 + Math.random() * 3).toFixed(1)} ms`;
  }

  setInterval(simulatePingJitter, 3000);
}

